export const SET_CONTENT_SCROLL = 'SET_CONTENT_SCROLL'

export const setScroll = ({ scrollTop, clientHeight, contentId }) => {
  return dispatch => {
    dispatch({ type: SET_CONTENT_SCROLL, payload: { scrollTop, clientHeight, contentId } })
  }
}
